const approvedDomainsConstantsEn = {
  approvedDomainsPageTitle: 'Approved Domains',
  approvedDomainsBreadcrumb: 'Approved Domains',
  approvedDomainsTableColumnDomain: 'Domain',
  approvedDomainsTableColumnAction: 'Action',
  approvedDomainsActionPanelBtn: 'Add new Domain',
  approvedDomainsAddPopUpTitle: 'Add new Domain',
  approvedDomainsUpdatePopUpTitle: 'Update Domain',
  approvedDomainsDeletePopUpTitle: 'Delete Domain',
  approvedDomainsAddBtn: 'Add',
  approvedDomainsUpdateBtn: 'Update',
  approvedDomainsDeleteBtn: 'Delete',
  approvedDomainsAddPopUpText: 'Add new domain, to skip registration approval process',
  approvedDomainsUpdatePopUpText: 'Update approved domain information',
  approvedDomainsDeletePopUpText: 'Are you sure you want to delete this domain?',
  approvedDomainsEditTooltip: 'Edit Domain',
  approvedDomainsDeleteTooltip: 'Delete Domain',
  approvedDomainsActionPanelBtnTooltip: 'Add new Domain',
  approvedDomainsTableTitleDomain: 'Domains',
  approvedDomainsTableTitleActions: 'Actions',
  approvedDomainsDialogEmptyFieldError: 'Please insert approved domain name',
};

export default approvedDomainsConstantsEn;
